"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isAsyncIterable = isAsyncIterable;
exports.asyncIsIterable = asyncIsIterable;
exports.asyncify = asyncify;
exports.asyncEnsureIterable = asyncEnsureIterable;
exports.isValidAsyncIterableArgument = isValidAsyncIterableArgument;
exports.AsyncMethodIterable = AsyncMethodIterable;
exports.asyncWrapWithMethodIterable = asyncWrapWithMethodIterable;
exports.asyncIterableCurry = void 0;

var _iterable = require("./iterable");

var _curry = require("./curry");

function isAsyncIterable(i) {
  return Boolean(i != null && i[Symbol.asyncIterator]);
}

function asyncIsIterable(i) {
  return isAsyncIterable(i) || (0, _iterable.isIterable)(i);
}

async function* asyncify(iterable) {
  if (isAsyncIterable(iterable)) {
    yield* iterable;
  } else {
    for (const item of iterable) {
      yield Promise.resolve(item);
    }
  }
}

function asyncEnsureIterable(i) {
  if (isAsyncIterable(i)) {
    return i;
  } else {
    return asyncify((0, _iterable.ensureIterable)(i));
  }
}

function isValidAsyncIterableArgument(i) {
  return isAsyncIterable(i) || (0, _iterable.isValidIterableArgument)(i);
}

function AsyncMethodIterable(...args) {
  _iterable.BaseMethodIterable.apply(this, args);
}

AsyncMethodIterable.prototype = Object.assign(Object.create(_iterable.BaseMethodIterable.prototype), {
  constructor: AsyncMethodIterable,

  [Symbol.asyncIterator]() {
    return this.__iterate();
  }

});

function AsyncSimpleMethodIterable(...args) {
  AsyncMethodIterable.apply(this, args);
}

AsyncSimpleMethodIterable.prototype = Object.assign(Object.create(AsyncMethodIterable.prototype), {
  __iterate() {
    return this._fn(...this._args);
  }

});

function makeFunctionConfig(fn, fnConfig = {}) {
  const {
    validateArgs,
    variadic,
    reduces,
    optionalArgsAtEnd,
    minArgs,
    maxArgs,
    forceSync
  } = fnConfig;
  return {
    fn,
    validateArgs: validateArgs || (_ => {}),
    variadic: !!variadic,
    reduces: !!reduces,
    optionalArgsAtEnd: !!optionalArgsAtEnd,
    minArgs: minArgs === undefined ? fn.length - 1 : minArgs,
    maxArgs: maxArgs === undefined ? fn.length - 1 : maxArgs,
    isIterable: isValidAsyncIterableArgument,
    iterableType: 'asyncIterable',
    applyOnIterableArgs: asyncEnsureIterable,
    IterableClass: forceSync ? _iterable.MethodIterable : AsyncMethodIterable
  };
}

function asyncWrapWithMethodIterable(fn, {
  validateArgs = _ => _
} = {}) {
  return (...args) => {
    validateArgs(args);
    return new AsyncSimpleMethodIterable(fn, args);
  };
}

const asyncIterableCurry = (fn, config) => {
  return (0, _curry.variadicCurryWithValidation)(makeFunctionConfig(fn, config));
};

exports.asyncIterableCurry = asyncIterableCurry;